import React from 'react';
import {MasterLayout} from 'components/layouts';
import {ProductForm} from 'components/my-business/manage-product';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import {Products} from 'base/api';
import {toastr} from 'react-redux-toastr';
import {withRouter} from 'react-router-dom';
import {BusinessLayout} from 'components/layouts/business';
import title from 'constants/TitlePages.js';

class MyBusinessEditProductPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      product: {}
    }

    Products.actions.get.request({id: this.props.match.params.id}).then(response => {
      this.setState({
        product: response.data
      })
    })
  }

  componentDidMount() {
    document.title = title.MyBusinessEditProductPage;
  }

  useUpdatedInfo(product) {
    if (product.requestUpdateInfo)
      return Object.assign({}, product, product.requestUpdateInfo);
    else {
      return product;
    }
  }

  cb(response) {
    // Back to categories list
    // do aprrove

    toastr.removeByType("success");
    toastr.success("", "Cập nhật thành công")
    // this.props.history.push(`/my-business/edit-product/${this.props.match.params.id}`);
  }

  render() {
    return (
      <MasterLayout>
        <BusinessLayout active='manage-product'>
          <ProductForm fnSubmit={Products.actions.update} cb={this.cb.bind(this)} data={this.useUpdatedInfo(this.state.product)} edit={true}/>
        </BusinessLayout>
      </MasterLayout>
    );
  }
}

export default BusinessZone(withRouter(MyBusinessEditProductPage));



// WEBPACK FOOTER //
// ./pages/my-business/MyBusinessEditProductPage.jsx